module.exports = __webpack_public_path__ + "img/czech-republic.0324d5fa.svg";